import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { LinkModule } from '../link';
import { LinkPopoverComponent } from './linkPopover.component';
import { PopoverComponent } from './popover.component';

/** Module de gestion des popovers de la lib. */
@NgModule({
	imports: [CommonModule, IonicModule, LinkModule],
	exports: [PopoverComponent, LinkPopoverComponent],
	declarations: [PopoverComponent, LinkPopoverComponent]
})
export class PopoverModule { }